module.exports = __webpack_public_path__ + "img/meal_placeholder.5dc4309a.png";